module.exports = __webpack_public_path__ + "img/pagi.eb1a5f91.jpg";